import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import {useNavigate} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {CircularProgress, IconButton, ListItemIcon, Menu, MenuItem, Paper} from "@mui/material";
import BinIcon from "@mui/icons-material/Delete";
import {api} from "../services/apiService";


export default function ProductOrOptionComponent({type, title}) {

    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const promises = [];

        promises.push(api.get(`/products/categories`)
            .then(response => {
                setCategories(response.data);
                setLoaded(prev => prev + 1);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            }));

        promises.push(api.get(`/${type}/list`)
            .then(response => {
                setData(response.data);
                setLoaded(prev => prev + 1);
            })
            .catch(error => {
                console.error(`Error fetching ${type}s:`, error);
            }));

        Promise.all(promises).then(() => {
            setLoaded(true)
        });
    }, [type]);

    return (
        loaded ? (
                <Container sx={{overflowX: "auto"}}>
                    <Typography variant="h1">{title}</Typography>

                    <Stack
                        sx={{
                            flexDirection: "row",
                            gap: "1rem",
                            justifyContent: {xs: "flex-start", sm: "flex-end"},
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                flexGrow: {xs: 1, sm: 0},
                                minWidth: 0,
                            }}
                            onClick={() => navigate(`/${type}/add`)}
                        >
                            <Typography variant="button">Ajouter</Typography>
                        </Button>
                    </Stack>

                    {/* Trois listes distinctes */}
                    <Box sx={{width: "100%", overflowX: "auto", mt: 3}}>
                        {categories.map((category) => (
                            <div key={category.id}>
                                <Typography variant="h5" gutterBottom>
                                    {category.name}
                                </Typography>
                                <ProductList
                                    data={data.filter((obj) => obj.category.id === category.id)} type={type}
                                />
                            </div>
                        ))}
                    </Box>

                </Container>
            )
            :
            (
                <Container maxWidth="lg" sx={{
                    mt: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh"
                }}>
                    <Stack spacing={2} alignItems="center">
                        <Box>
                            <Typography variant="h6" sx={{mb: 2}}>Chargement...</Typography>
                            <Box sx={{display: "flex", justifyContent: "center"}}>
                                <CircularProgress color="primary"/>
                            </Box>
                        </Box>
                    </Stack>
                </Container>
            )
    );
}


function ProductList({data, type}) {
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 5,
        page: 0,
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const navigate = useNavigate();

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const handleMenuItemClick = (action) => {
        if (action === "edit") {
            navigate(`/${type}/edit/${selectedRow.id}`);
        } else if (action === "delete") {
            api.delete(`/${type}/delete/${selectedRow.id}`)
                .then(() => {
                    // Met à jour la liste après suppression
                    window.location.reload();
                })
                .catch(error => {
                    console.error(`Error deleting ${type}:`, error);
                });
        }
        handleCloseMenu();
    };

    const columns = [
        {field: "name", headerName: "Produit", flex: 1.5, minWidth: 200},
        {
            field: "price_ttc",
            headerName: "Prix TTC (€)",
            flex: 0.7,
            minWidth: 100,
            valueFormatter: (params) =>
                params.toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                }),
        },
        {
            field: "actions",
            headerName: "",
            width: 10,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton onClick={(event) => handleMenuClick(event, params.row)}>
                    <EditIcon/>
                </IconButton>
            ),
        },
    ];

    if (type === "products") {
        columns.splice(1, 0, {
            field: "duration",
            headerName: "Durée",
            flex: 0.7,
            minWidth: 120,
            valueFormatter: (params) => {
                // Affiche jours, heures, sinon en minutes
                return params >= 1440 ? `${(params / 1440).toFixed(0)}j` + (params % 1440 ? ` ${(params % 1440) / 60}h` + (params % 60 ? ` ${(params % 60)}min` : '') : '') : params >= 60 ? `${(params / 60).toFixed(0)}h` + (params % 60 ? ` ${(params % 60)}min` : '') : `${params}min`;
            }
        })
    }

    return (
        <Paper sx={{height: "400px", width: "100%", mb: 2}}>
            <DataGrid
                rows={data}
                columns={columns}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[5, 10, 25]}
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#f5f5f5",
                    },
                    backgroundColor: "#fff",
                }}
            />

            <Menu
                id="lock-menu"
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorEl={anchorEl}
                slotProps={{
                    paper: {
                        elevation: 1,
                    },
                }}
            >
                <MenuItem onClick={() => handleMenuItemClick("edit")}>
                    <ListItemIcon>
                        <EditIcon/>
                    </ListItemIcon>
                    Modifier
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("delete")}>
                    <ListItemIcon>
                        <BinIcon/>
                    </ListItemIcon>
                    Supprimer
                </MenuItem>
            </Menu>
        </Paper>
    );
}